// @flow

import React, { Fragment } from 'react';
import { Button } from 'reactstrap';

import { WhitePanel } from '../../../components';
import CheckAvailability from './CheckAvailability';
import { getFromCookies } from '../helpers';
import { formatToShow, padSAtTheEndIfPlural } from '../../../lib/helpers';

type Props = {
  openModal: () => void,
};

export default function SelectedInputs(props: Props) {
  const { openModal } = props;
  const { checkinDate, checkoutDate, pax } = getFromCookies();

  return (
    <Fragment>
      {checkinDate && checkoutDate ? (
        <WhitePanel>
          <h2>Your Selection</h2>
          <section className="selected__date">
            <div className="selected__date_checkin">
              <h6 className="date_title">Check In Date</h6>
              <h6 className="date_data">{formatToShow(checkinDate)}</h6>
            </div>
            <div className="selected__date_checkout">
              <h6 className="date_title">Check Out Date</h6>
              <h6 className="date_data">{formatToShow(checkoutDate)}</h6>
            </div>
            <div className="selected__date_guest">
              <h6 className="date_title">Guest</h6>
              <h6 className="date_data">{pax} {padSAtTheEndIfPlural(pax, 'Trekker')}</h6>
            </div>
            <div className="selected__date_action">
              <Button color="yellow-outline" onClick={openModal}>
                Change Search
              </Button>
            </div>
          </section>
        </WhitePanel>
      ) : (
        <CheckAvailability />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/SelectedInputs.js